import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "text-neutral2-600 bg-tile text-lg relative z-[2] lg:shadow" }
const _hoisted_3 = { class: "h-17.5 p-3 pl-4 lg:gap-x-4 flex items-center mx-auto max-w-400" }

import {computed, ref} from "vue";
import Icon from "../../../Icon/Icon.vue";
import {IconName} from "../../../Icon/icons";
import {NavigationAction} from "../../Port/NavigationService";
import {useNavigationStore} from "../navigationStore";
import {entryPointItems} from "../Presenter/entryPointItems";
import {useNavigationService} from "../vue";
import BrandLogo from "./BrandLogo.vue";
import DesktopAuthControl from "./DesktopAuthControl.vue";
import NavTopbarListItem from "./ListItem/NavTopbarListItem.vue";
import MobileDrawer from "./MobileDrawer.vue";
import NotificationControl from "./NotificationControl.vue";
import SearchField from "./SearchField.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'NavigationTopbar',
  setup(__props) {

const service = useNavigationService();
const store = useNavigationStore();
const mobileMenuOpen = ref<boolean>(false);

function toggleMobileMenu(): void {
  mobileMenuOpen.value = !mobileMenuOpen.value;
  service.mainContentSuspended(mobileMenuOpen.value);
}

function closeMobileMenu(): void {
  mobileMenuOpen.value = false;
  service.mainContentSuspended(false);
}

const mobileMenuIcon = computed<IconName>(() => mobileMenuOpen.value ? 'mobileMenuClose' : 'mobileMenuOpen');

function action(action: NavigationAction): void {
  service.action(action);
}

function markAll(): void {
  service.markAllNotificationsAsViewed();
}

function loadMore(): void {
  service.loadMoreNotifications();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (mobileMenuOpen.value)
      ? (_openBlock(), _createBlock(MobileDrawer, {
          key: 0,
          onClose: closeMobileMenu,
          class: "lg:hidden"
        }))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BrandLogo),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(entryPointItems), (item) => {
          return (_openBlock(), _createBlock(NavTopbarListItem, {
            type: item.type,
            title: item.title,
            action: item.action,
            "forum-menu": item.forumMenu,
            children: item.children,
            "children-for-not-authenticated": item.childrenForNotAuthenticated,
            onAction: action
          }, null, 8 /* PROPS */, ["type", "title", "action", "forum-menu", "children", "children-for-not-authenticated"]))
        }), 256 /* UNKEYED_FRAGMENT */)),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "ml-auto" }, null, -1 /* CACHED */)),
        _createVNode(SearchField),
        _createVNode(NavTopbarListItem, {
          type: "buttonSecondary",
          class: "max-lg:hidden",
          title: "Dodaj ofertę pracy",
          action: "pricing",
          onAction: action
        }),
        (_unref(store).isAuthenticated)
          ? (_openBlock(), _createBlock(NotificationControl, {
              key: 0,
              user: _unref(store).navigationUser!,
              onMarkAll: markAll,
              onLoadMore: loadMore
            }, null, 8 /* PROPS */, ["user"]))
          : _createCommentVNode("v-if", true),
        _createVNode(DesktopAuthControl, {
          class: "max-lg:hidden",
          user: _unref(store).navigationUser
        }, null, 8 /* PROPS */, ["user"]),
        _createVNode(Icon, {
          monospace: "",
          name: mobileMenuIcon.value,
          onClick: toggleMobileMenu,
          class: "text-xl mr-4 lg:hidden"
        }, null, 8 /* PROPS */, ["name"])
      ])
    ])
  ]))
}
}

})